var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGymPin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5681 36.2519L20 36.9923L20.4319 36.2519L26.6557 25.5826C30.166 23.3704 32.5 19.458 32.5 15C32.5 8.09644 26.9036 2.5 20 2.5C13.0964 2.5 7.5 8.09644 7.5 15C7.5 19.458 9.83398 23.3704 13.3443 25.5826L19.5681 36.2519Z",
    fill: "#111418",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.001 17.002L13 16.001L14.001 15L16.5 17.499L22.499 11.5L20 9.001L21.001 8L22.002 9.001L23.003 8L24.501 9.498L25.502 8.497L26.503 9.498L25.502 10.499L27 11.997L25.999 12.998L27 13.999L25.999 15L23.5 12.501L17.501 18.5L20 20.999L18.999 22L17.998 20.999L16.997 22L15.499 20.502L14.498 21.503L13.497 20.502L14.498 19.501L13 18.003L14.001 17.002Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGymPin);
export default __webpack_public_path__ + "static/media/gym-pin.d13df3cb127df4791c79cef5dcc4c743.svg";
export { ForwardRef as ReactComponent };